import {SchoolLevel} from '../user/school-level.model';

export class YoungEditInformationDto {
    id: number;
    firstName: string;
    lastName: string;
    height: number;
    weight: number;
    medicalObservation: string;
    handicap: string;
    schoolLevel: SchoolLevel;
    scolarDifficultyIds: number[];
    disciplineScolarDifficultyIds: number[];
}
